import faqService from '../../services/FaqService'

const state = {
    faqs: []
};

const mutations = {
    SET_FAQS(state, faqs) {
        state.faqs = faqs;
    }
};

const actions = {
    async fetchPublicFaqs({ commit }) {
        try {
            const { data } = await faqService.get();
            commit('SET_FAQS', data.itens);
        } catch (error) {
            console.error('Erro ao buscar FAQs:', error);
        }
    }
};

const getters = {
    getFAQs: state => state.faqs
};

export default {
    state,
    mutations,
    actions,
    getters
};
